<template>
    <div class="card card-body shadow">
        <owl-data-grid class="table table-striped" url="pengajuan-list" :columns="this.columns" :dataCounts="[9, 3 * 9, 9 * 9]" @set-datas="(data) => datas = data">
            <div class="col-12 col-md-4" v-for="data in datas" v-bind:key="data">
                <router-link :to="{ name: 'ujilab.penerimaan.form', params: { id: data.id } }">
                    <div class="card card-body mb-3 shadow">
                        <div class="d-flex justify-content-between">
                            <div class="h3 text-truncate"> {{ data.kode_tracking }}</div>
                            <div class="h6 text-truncate fw-light"> {{ data.tanggal }}</div>
                        </div>
                        <div class="h6 text-truncate">Pemohon : {{ data.nama }} ({{ data.instansi }})</div>
                        <small>Status: {{ data.status }}</small>
                    </div>
                </router-link>
            </div>
        </owl-data-grid>
</div>
</template>

<script>
import OwlDataGrid from '@/components/OwlDataGrid.vue';

export default {
    name: "UjilabPenerimaanIndex",
    components: { OwlDataGrid },
    data() {
        return {
            datas: {},
            formsData: {},
            columns: [
                {
                    data: 'Kode Sampel',
                    name: 'id',
                    orderable: true
                },
                {
                    data: 'Tanggal',
                    name: 'tanggal',
                    orderable: true
                },
            ]
        }
    },
}
</script>